export const LANGUAGES = [
  { code: "en", label: "English", native: "English", dir: "ltr" },
  { code: "ur", label: "Urdu", native: "اردو", dir: "rtl" },
  { code: "ta", label: "Tamil", native: "தமிழ்", dir: "ltr" },
  { code: "sw", label: "Swahili", native: "Kiswahili", dir: "ltr" },
  { code: "ms", label: "Bahasa Melayu", native: "Bahasa Melayu", dir: "ltr" },
  { code: "id", label: "Bahasa Indonesia", native: "Bahasa Indonesia", dir: "ltr" },
  { code: "hi", label: "Hindi", native: "हिन्दी", dir: "ltr" },
];

// Optional future codes reserved in the 20-language roadmap
export const ROADMAP_LANGUAGES = [
  ...LANGUAGES,
  { code: "ps", label: "Pashto", native: "پښتو", dir: "rtl", disabled: true },
  { code: "ks", label: "Kashmiri", native: "کٲشُر", dir: "rtl", disabled: true },
];

export const STRINGS = {
  en: {
    brand: "HikmahVerses",
    tagline: "600 Stories",
    hero_1: "One story a day,",
    hero_2: "a lifetime",
    hero_3: "with the Qur'an.",
    hero_sub: "Six hundred illustrated Qur'an stories, one per Mushaf page — a guided six-year journey for children ages 8 to 13.",
    start_membership: "Start Membership",
    watch_sample: "Watch a Sample Story",
    stat_1: "2 new stories / week",
    stat_1_sub: "Two 5-min animated videos every week",
    stat_2: "600 stories over 60 months",
    stat_2_sub: "One story per Mushaf page, 30 Juz covered",
    stat_3: "1 weekly live class",
    stat_3_sub: "Sunday recap, Q&A, and short assignment",
    weekly: "The Weekly Routine",
    weekly_sub: "Two stories a week, 10 minutes a day, one live class on Sunday.",
    inside: "This Week Inside",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    today: "Today",
    progress: "Progress",
    admin: "Admin",
    family_mode: "Family Mode",
    read_story: "Read Story",
    watch_video: "Watch Video",
    take_quiz: "Take Quiz",
    word_of_the_day: "Word of the Day",
    morals: "Morals",
    ayah: "Ayah of the Story",
    quiz: "Interactive Quiz",
    references: "Go Deeper",
    complete_all_days: "Complete each day's activity to unlock the next.",
    live_sunday: "LIVE · Sunday",
    email: "Email",
    password: "Password",
    name: "Name",
    age: "Age",
    language: "Language",
    parent_email: "Parent / Guardian Email",
    role: "I am a…",
    role_student: "Student",
    role_parent: "Parent / Guardian",
    role_teacher: "Teacher",
    submit: "Submit",
    continue: "Continue",
    enroll_cohort: "Enroll in Cohort",
    choose_cohort: "Choose your monthly starting cohort",
    already_have_account: "Already have an account?",
    no_account: "New to HikmahVerses?",
    days_left_in_cycle: "Day {n} of your 7-day cycle",
    juz: "Juz",
    story: "Story",
    locked: "Locked",
    unlocked: "Unlocked",
    completed: "Completed",
    price_month: "$10 / month",
    price_sub: "Cancel anytime · Family mode included",
    faq: "Frequently Asked",
    faq_1_q: "How does the six-year journey work?",
    faq_1_a: "Two stories release every week, one story per Mushaf page, across all 30 Juz. Sunday is a live recap class on YouTube.",
    faq_2_q: "Can parents use it for bedtime?",
    faq_2_a: "Yes — Family Mode lets parents freely browse any already-released story out of schedule order, for younger siblings.",
    faq_3_q: "What ages is this for?",
    faq_3_a: "Ages 8 to 13 (grades 4–8), with a separate unscheduled Family Mode for bedtime reading by parents and grandparents.",
    faq_4_q: "Is there depiction of Prophets?",
    faq_4_a: "No. Modest visuals, vocals-only audio, religious QA review before release.",
    steps_title: "Every story, five parts",
    steps_sub: "Each Story Bundle is watched, read, reflected on, memorized, and tested.",
    step_video: "5-minute Video",
    step_video_sub: "A narrated, animated story — safe visuals, no depictions of Prophets.",
    step_book: "Cartoon Storybook",
    step_book_sub: "The same story as a page-flip illustrated storybook to re-read.",
    step_morals: "3 Morals + 1 Ayah",
    step_morals_sub: "Life lessons drawn from the story, tied to a verse in Arabic.",
    step_word: "1 Word of the Day",
    step_word_sub: "One Arabic word from the story — transliteration and meaning.",
    step_quiz: "Interactive Quiz",
    step_quiz_sub: "A short multi-choice quiz plus references to go deeper.",
    footer_note: "600 stories · 30 Juz · one journey.",
    submit_answers: "Submit answers",
    check_answers: "Check my answers",
    score: "Your score",
    quiz_pass: "Beautiful work — story complete!",
    quiz_almost: "Almost there.",
    quiz_got: "You got",
    quiz_retry: "have another go at the ones with a lightbulb.",
    quiz_correct: "Yes — that's it!",
    quiz_try_again: "Not quite — have another look.",
    quiz_pick_one: "Pick one answer.",
    onboarding_title: "Tell us a little about you",
    onboarding_sub: "So we can set up your six-year journey.",
    save_profile: "Save & Continue",
    enroll_help: "You can only enroll into the start of an upcoming month.",
    enrolled_in: "Enrolled in cohort",
    cohort_starts: "Starts",
    not_enrolled: "Your stories start next Monday. Story 1 is open now.",
    enroll_now: "Enroll now",
    stories_done: "Stories done",
    juz_done: "Juz done",
    streak: "Day streak",
    live_soon: "This week's recap video embeds here. Coming soon.",
    admin_title: "Story CMS",
    admin_sub: "Create, edit or bulk-import the 600 stories.",
    seq: "Global sequence",
    juz_num: "Juz",
    story_num: "Story in Juz",
    title: "Title (English)",
    create_story: "Save story",
    bulk_import: "Bulk import JSON",
    close: "Close",
  },
  ur: {
    brand: "حِکمہ ورسیز",
    tagline: "چھ سو کہانیاں",
    hero_1: "روز ایک کہانی،",
    hero_2: "پوری زندگی",
    hero_3: "قرآن کے ساتھ۔",
    hero_sub: "قرآن کی چھ سو مصور کہانیاں — بچوں کے لیے چھ سالہ رہنما سفر۔",
    start_membership: "ابھی شروع کریں",
    watch_sample: "نمونہ دیکھیں",
    login: "لاگ ان",
    signup: "رجسٹر",
    today: "آج",
    progress: "پیش رفت",
    admin: "منتظم",
  },
};

export function t(lang, key) {
  return (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
}

export function langDir(code) {
  const l = LANGUAGES.find((x) => x.code === code);
  return l ? l.dir : "ltr";
}
